import AcademyList from "src/components/Academy/AcademyList"

const AcademyPage: React.FC = () => {
  return (
    <div>
      <AcademyList type={'userlogin'} />
    </div>
  )
}
export default AcademyPage